export default __webpack_public_path__ + "static/media/marketing-main.a2f94751.jpg";